import React from 'react';
import {Link} from 'react-router-dom';

import {Icon} from 'components/baseIcon/baseIcon';
import * as PointIcon from 'components/__helpers/icon/svg/common/point.svg';

import s from './orderTracking.scss';

/**
 * Order Tracking menu item with flag
 * @param {PropsType} props - PropsType
 * @return {React.FC} - OrderTrackingWithFlag
 */
export const OrderTracking: React.FC = () => (
    <Link to="/tracking/search/">
        <div className={s.wrapName}>
            <span className={s.name}>Order Tracking</span>
            <div className={s.point}>
                <Icon icon={PointIcon} />
            </div>
        </div>
    </Link>
);
